import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import AddressSection from "@/pages/home/components/AddressSection";
import DomainSection from "@/pages/home/components/DomainSection";
import DownloadSection from "@/pages/home/components/DownloadSection";
import ChannelsSection from "@/pages/home/components/ChannelsSection";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import CollectionSection from "@/pages/home/components/CollectionSection";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";

export default function Home() {
  return (
    <div className="w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <AddressSection />
        <DomainSection />
        <DownloadSection />
        <ChannelsSection />
        <GuideSection />
        <FaqSection />
        <CollectionSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}